/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Metric } from './Metric';
import {
    MetricFromJSON,
    MetricFromJSONTyped,
    MetricToJSON,
    MetricToJSONTyped,
} from './Metric';

/**
 * 
 * @export
 * @interface BranchOrderTagsNetSalesResponse
 */
export interface BranchOrderTagsNetSalesResponse {
    /**
     * 
     * @type {Array<Metric>}
     * @memberof BranchOrderTagsNetSalesResponse
     */
    data: Array<Metric>;
}

/**
 * Check if a given object implements the BranchOrderTagsNetSalesResponse interface.
 */
export function instanceOfBranchOrderTagsNetSalesResponse(value: object): value is BranchOrderTagsNetSalesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BranchOrderTagsNetSalesResponseFromJSON(json: any): BranchOrderTagsNetSalesResponse {
    return BranchOrderTagsNetSalesResponseFromJSONTyped(json, false);
}

export function BranchOrderTagsNetSalesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BranchOrderTagsNetSalesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MetricFromJSON)),
    };
}

export function BranchOrderTagsNetSalesResponseToJSON(json: any): BranchOrderTagsNetSalesResponse {
    return BranchOrderTagsNetSalesResponseToJSONTyped(json, false);
}

export function BranchOrderTagsNetSalesResponseToJSONTyped(value?: BranchOrderTagsNetSalesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(MetricToJSON)),
    };
}

